$(document).ready(function() {      
  filter.init();
});

var filter = {
  isSidebarAjaxClick: false,
  init: function() {
	this.sidebarMapTagEvents();
    this.clear_all();
    this.toggle_filter();
    this.current_tag_bar();
  },
  
  sidebarMapTagEvents: function() {            
    $('.advanced-filters .advanced-filter').click(function(e){
        e.preventDefault();
        var new_url = $(this).find('a').attr('href');
        History.pushState({
          param: Shopify.queryParams
        }, new_url, new_url);
        filter.sidebarGetContent(new_url);
    });
  },
  
  sidebarGetContent: function(newurl) {
 
    $.ajax({
      type: 'get',
      url: newurl,
      beforeSend: function() {
     	$('.loading-modal').show();
	   },
      success: function(data) {
        var paginationCustom = $(data).find('.pagePagination').html();
        $("#jquery_jplayer_N").jPlayer("destroy");
        filter.sidebarMapData(data);
        filter.sidebarMapTagEvents();
        filter.current_tag_bar();
        play_list();
        $('.pagePagination').html(paginationCustom);
         $('.loading-modal').hide();
       
      },
      error: function(xhr, text) {
        
      }
    });
  },
  
  sidebarMapData: function(data){
    
    $('body').removeClass('overlay');
    
    $("#collectionFilters").replaceWith($(data).find("#collectionFilters"));
    
    $("#collection_pro_list").replaceWith($(data).find("#collection_pro_list"));
    
    
    $(".current_tag_bar").replaceWith($(data).find(".current_tag_bar"));
    
    $(".breadcrumb").replaceWith($(data).find(".breadcrumb"));
    
    $(".collection-playlist").replaceWith($(data).find(".collection-playlist"));
   
  },
  
  clear_all: function(data){
    
    $('body').on('click','.clear_all',function(e){
      
    	e.preventDefault();
        var new_url = $(this).attr('href');
     
        History.pushState({
          param: Shopify.queryParams
        }, new_url, new_url);
        filter.sidebarGetContent(new_url);
    });
    
  },
  
  toggle_filter: function(){
    $('body').on('click','#toggleFilters',function(){
      $(this).toggleClass('is-active');
      $('body').toggleClass('overlay');
      $('.close-pop').toggleClass('show');
      $('#collectionFilters').slideToggle(200);
	});
  },
  
  current_tag_bar:function(){
    $('.current_tag_bar a span').click(function(){
    	var tag = $(this).closest('a').data('handle');
        $('.advanced-filters .active-filter').each(function(){
          if($(this).data('handle') == tag ){
          	$(this).trigger('click');
            return false;
          } 
        });
    });
  },
  
}